import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Testimonianze degli studenti" className="bg-transparent" data-id="element-204" data-mp="3ksgyi97eejdg">
      <div className="mx-auto max-w-6xl px-5 py-10" style={{
      paddingTop: "14px",
      paddingBottom: "15px"
    }} data-id="element-205" data-mp="3fy2zzxxfvw4k">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-206" data-mp="3b0ayqdawmxnp">
          🗣️ Testimonianze reali di persone che hanno iniziato
        </h2>
        <div className="mt-8 grid w-full grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-207" data-mp="31yuuyoelhtsg">
          {testimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.1} data-id="element-208" data-mp="2x1bjtxd71x4q" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}